import React from 'react';
import { PhoneOff, Loader2 } from 'lucide-react';

const EndCallButton = ({ onClick, isEnding }) => {
  return (
    <div className="relative group">
      <button
        onClick={onClick}
        disabled={isEnding}
        className={`
          relative px-8 py-4 rounded-2xl font-semibold transition-all duration-300
          shadow-2xl hover:shadow-3xl hover:scale-105 active:scale-95
          disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100
          ${isEnding
            ? 'bg-gradient-to-r from-gray-700 to-gray-800'
            : 'bg-gradient-to-r from-red-500 via-rose-600 to-pink-600 hover:from-red-600 hover:via-rose-700 hover:to-pink-700'
          }
        `}
      >
        {/* Glow effect */}
        <div className={`
          absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500
          bg-gradient-to-r from-red-500/30 via-rose-600/30 to-pink-600/30 blur-xl
          ${isEnding && 'hidden'}
        `}></div>

        {/* Content */}
        <div className="relative z-10 flex items-center gap-3">
          {isEnding ? (
            <>
              <div className="relative">
                <Loader2 className="w-6 h-6 text-white animate-spin"/>
                <div className="absolute inset-0 animate-ping bg-white/20 rounded-full"></div>
              </div>
              <span className="text-white">Ending Call...</span>
            </>
          ) : (
            <>
              <div className="relative">
                <PhoneOff className="w-6 h-6 text-white"/>
                {/* Pulse animation */}
                <div className="absolute inset-0 animate-ping bg-red-400/30 rounded-full"></div>
              </div>
              <span className="text-white text-lg">End Call</span>
            </>
          )}
        </div>

        {/* Countdown indicator (optional) */}
        {isEnding && (
          <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-gray-700 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-red-500 to-rose-600 animate-[progress_3s_linear]"></div>
          </div>
        )}
      </button>

      {/* Warning tooltip */}
      {!isEnding && (
        <div className="absolute -top-20 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none">
          <div className="relative">
            <div className="bg-gray-900/95 backdrop-blur-md text-white text-sm px-4 py-3 rounded-xl shadow-2xl border border-white/10">
              <div className="flex items-center gap-2 text-red-300">
                <span>⚠️</span>
                <span>End call for both participants</span>
              </div>
            </div>
            {/* Tooltip arrow */}
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rotate-45 w-3 h-3 bg-gray-900/95 border-r border-b border-white/10"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EndCallButton;
